import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { styled } from '@mui/material/styles';
import { useStore } from '@base-ui/utils/store/useStore';
import { useAdapterContext } from '@mui/x-scheduler-headless/use-adapter-context';
import { eventTimelinePremiumViewSelectors } from '@mui/x-scheduler-headless-premium/event-timeline-premium-selectors';
import { useEventTimelinePremiumStoreContext } from '@mui/x-scheduler-headless-premium/use-event-timeline-premium-store-context';
import { processDate } from '@mui/x-scheduler-headless/process-date';
import { useEventTimelinePremiumStyledContext } from "../../EventTimelinePremiumStyledContext.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const YearsHeaderRoot = styled('div', {
  name: 'MuiEventTimeline',
  slot: 'YearsHeader'
})({
  display: 'grid',
  gridTemplateColumns: 'repeat(var(--unit-count), minmax(var(--years-cell-width), 1fr))',
  gridTemplateRows: 'auto',
  height: '100%'
});
const YearLabel = styled('div', {
  name: 'MuiEventTimeline',
  slot: 'YearsHeaderYearLabel'
})(({
  theme
}) => ({
  padding: theme.spacing(1),
  textAlign: 'center',
  fontSize: theme.typography.body2.fontSize,
  fontWeight: theme.typography.fontWeightMedium,
  '&:not(:last-child)': {
    borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
  }
}));
export function YearsHeader(props) {
  // Context hooks
  const adapter = useAdapterContext();
  const store = useEventTimelinePremiumStoreContext();
  const {
    classes
  } = useEventTimelinePremiumStyledContext();

  // Selector hooks
  const viewConfig = useStore(store, eventTimelinePremiumViewSelectors.config);

  // Feature hooks
  const years = React.useMemo(() => getYears(adapter, viewConfig.start, viewConfig.end), [adapter, viewConfig]);
  return /*#__PURE__*/_jsx(YearsHeaderRoot, _extends({
    className: classes.yearsHeader
  }, props, {
    children: years.map(year => /*#__PURE__*/_jsx(YearLabel, {
      className: classes.yearsHeaderYearLabel,
      children: adapter.getYear(year.value)
    }, year.key))
  }));
}
function getYears(adapter, start, end) {
  let current = adapter.startOfYear(start);
  const years = [];
  while (adapter.isBefore(current, end)) {
    years.push(processDate(current, adapter));
    current = adapter.addYears(current, 1);
  }
  return years;
}